import dayjs from 'dayjs'

import {
  ClassifiedCoordinatorBlock,
  ContractType,
} from '../../rest/types/Classified'

export function BlockCoordinatorTransformer({
  block,
  t,
}: {
  block: ClassifiedCoordinatorBlock
  t: any
}) {
  return {
    ...((block?.startDate || block?.endDate) && {
      adsReplacementDate: {
        title: t('ads_replacement_date_title'),
        ...(block?.startDate && {
          subtitle: {
            label: block?.contract.includes(ContractType.Cdi)
              ? t('ads_replacement_date_employee_subtitle')
              : t('ads_replacement_date_replacement_subtitle'),
            requestedDate: dayjs(block?.startDate).format('DD MMMM YYYY'),
          },
        }),
        periods: {
          label: t('ads_replacement_date_period_label'),

          ...(block?.startDate && {
            start: dayjs(block?.startDate).format('DD MMMM YYYY'),
          }),
          ...(block?.endDate && {
            finish: dayjs(block?.endDate).format('DD MMMM YYYY'),
          }),
        },
      },
    }),
    ...(block?.specialities?.length && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          {
            title: t('adsForm_coordinatorBlock_speciality_label'),
            texts: block.specialities.map((item) => item.name),
          },
        ],
      },
    }),

    adsDetails: {
      items: [
        {
          label: t('ads_details_saturday_title'),
          value: block?.saturday
            ? t('form_boolean_value_true')
            : t('form_boolean_value_false'),
        },
        {
          label: t('ads_details_experience_title'),
          value: block?.experience
            ? t('ads_details_experience_required')
            : t('ads_details_experience_beginner'),
        },
        ...(block?.contract?.length
          ? [
              {
                label: t('ads_details_contract_type_title'),
                values: block?.contract?.map((item) =>
                  t(`ads_details_contract_type_${item}`)
                ),
              },
            ]
          : []),
      ],
    },
  }
}
